import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";

export default function AboutSection() {
    const [aboutSections, setAboutSections] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
    };

    useEffect(() => {
        getAbout();
    }, []);

    const getAbout = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETABOUT, headerconfig)
            .then((res) => {
                if (res.data.data?.length > 0) {
                    setAboutSections(res.data.data);
                    setOriginalData(res.data.data);
                }
            })
            .catch((err) => console.error(err));
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updated = [...aboutSections];
        updated[index][name] = value;
        setAboutSections(updated);
    };

    const validate = () => {
        let tempErrors = aboutSections.map((item) => ({
            title: item.title ? true : false,
            description: item.description ? true : false,
        }));
        setErrors(tempErrors);
        return tempErrors.every((item) => item.title && item.description);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await Promise.all(
                aboutSections.map((item) =>
                    axios.put(
                        `${config.APIACTIVATEURL}${config.UPDATEABOUT}/${item.aboutSectionId}`,
                        { ...item, updatedDate: new Date().toISOString() },
                        headerconfig
                    )
                )
            );
            handleSuccess("About section updated successfully");
            setIsEditMode(false);
            getAbout();
        } catch (err) {
            console.error(err);
            handleError("Update failed");
        }
    };

    const handleCancel = () => {
        setAboutSections([...originalData]);
        setIsEditMode(false);
    };

    const applyErrorClass = (index, field) =>
        errors[index]?.[field] === false ? " is-invalid" : "";

    return (
        <div id="layout-wrapper">
                <Header />
                <SideBar />
                <div className="vertical-overlay" />
            
                {/* Use the same structure as your working screen */}
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* Hero section starts */}
                            <div className="layout-wrapper mb-5"></div>
            {aboutSections.map((item, index) => (
                <div className="container mt-5" key={item.aboutSectionId}>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="text-center mb-3">
                                <h2 className="mb-3 fw-semibold lh-base outfit">{item.title}</h2>
                                <p className="text-black outfit fs-4">{item.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <hr style={{ border: "3px solid black", margin: "40px 0" }} />

            {/* Edit Form */}
            {aboutSections.length > 0 && (
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">About Section Settings</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {aboutSections.map((item, index) => (
                                        <div className="mb-4" key={item.aboutSectionId}>
                                            <h5 className="fw-bold">Section {index + 1}</h5>
                                            <div className="mb-3">
                                                <label className="form-label">Title</label>
                                                <textarea
                                                    name="title"
                                                    value={item.title}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    className={`form-control${applyErrorClass(index, "title")}`}
                                                    rows={1}
                                                    readOnly={!isEditMode}
                                                />
                                                {errors[index]?.title === false && (
                                                    <div className="invalid-feedback">Title is required</div>
                                                )}
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    name="description"
                                                    value={item.description}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    className={`form-control${applyErrorClass(index, "description")}`}
                                                    rows={3}
                                                    readOnly={!isEditMode}
                                                />
                                                {errors[index]?.description === false && (
                                                    <div className="invalid-feedback">Description is required</div>
                                                )}
                                            </div>
                                            <hr />
                                        </div>
                                    ))}
                                    <div className="d-flex justify-content-end gap-2">
                                        {isEditMode ? (
                                            <>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary">
                                                    Save Changes
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-warning"
                                                onClick={() => setIsEditMode(true)}
                                            >
                                                Edit
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
        </div>
        </div>
    );
}
